import { useState } from "react";
import { api } from "@/lib/api";
import { useT } from "@/lib/i18n";
import { Mail, Loader2, CheckCircle2 } from "lucide-react";

export const ReceiptEmail = ({ orderId, accent, defaultEmail = "", onSent }) => {
  const { t } = useT();
  const [email, setEmail] = useState(defaultEmail);
  const [busy, setBusy] = useState(false);
  const [sentTo, setSentTo] = useState("");
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await api.post(`/orders/${orderId}/receipt`, { email });
      setSentTo(data.email);
      onSent?.(data.email);
    } catch (err) {
      const status = err.response?.status;
      setError(status === 422 ? t("receiptInvalid") : err.response?.data?.detail?.limit_reached || status === 503 ? t("receiptUnavailable") : t("receiptError"));
    } finally {
      setBusy(false);
    }
  };

  if (sentTo)
    return (
      <div data-testid="receipt-sent" className="bg-white rounded-2xl border border-[#E6E1DA] p-4 flex items-center gap-3">
        <CheckCircle2 className="h-5 w-5 text-emerald-600 shrink-0" />
        <p className="text-sm text-[#1F1D1B] flex-1 min-w-0 break-words">{t("receiptSent", { email: sentTo })}</p>
        <button data-testid="receipt-send-another" onClick={() => setSentTo("")} className="text-xs font-semibold shrink-0" style={{ color: accent }}>{t("receiptAgain")}</button>
      </div>
    );

  return (
    <form data-testid="receipt-form" onSubmit={submit} className="bg-white rounded-2xl border border-[#E6E1DA] p-4 space-y-3">
      <p className="text-sm font-semibold text-[#1F1D1B] flex items-center gap-2"><Mail className="h-4 w-4" style={{ color: accent }} /> {t("emailReceipt")}</p>
      <div className="flex gap-2">
        <input data-testid="receipt-email-input" type="email" required autoComplete="email" inputMode="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" className="flex-1 min-w-0 bg-[#FAF7F2] border border-[#E6E1DA] rounded-xl px-4 py-3 text-sm focus:outline-none" />
        <button data-testid="receipt-send-button" disabled={busy} className="rounded-xl px-4 font-semibold text-white text-sm inline-flex items-center gap-1.5 disabled:opacity-60 transition-transform active:scale-95" style={{ backgroundColor: accent }}>
          {busy && <Loader2 className="h-4 w-4 animate-spin" />} {t("send")}
        </button>
      </div>
      {error && <p data-testid="receipt-error" className="text-xs text-red-600">{error}</p>}
    </form>
  );
};
